export default __webpack_public_path__ + "static/media/aabt.5a52977b.png";